import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

interface KpiCardProps {
  title: string
  value: string
  trend?: number
  trendLabel?: string
  icon?: ReactNode
  className?: string
}

export function KpiCard({ title, value, trend, trendLabel, icon, className }: KpiCardProps) {
  const isPositive = trend !== undefined && trend >= 0
  return (
    <div className={cn('rounded-xl border border-border bg-card p-5 shadow-sm transition-colors hover:bg-accent/40', className)}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-muted-foreground">{title}</span>
        {icon && <div className="rounded-lg bg-foreground/5 p-2">{icon}</div>}
      </div>
      <div className="mt-3">
        <span className="text-2xl font-semibold text-foreground">{value}</span>
        {trend !== undefined && (
          <div className="mt-1 flex items-center gap-1.5">
            <span className={cn('text-xs font-medium', isPositive ? 'text-sky-600' : 'text-red-500')}>
              {isPositive ? '+' : ''}{trend}%
            </span>
            {trendLabel && <span className="text-xs text-muted-foreground">{trendLabel}</span>}
          </div>
        )}
      </div>
    </div>
  )
}
